import dayjs from 'dayjs';
import type { IPresetConfig, TPresetKey } from './types';

export const presetMap: Record<TPresetKey, IPresetConfig> = {
  last_week: { label: 'Last Week', value: [dayjs().subtract(7, 'd'), dayjs()] },
  last_2_weeks: { label: 'Last 2 Weeks', value: [dayjs().subtract(14, 'd'), dayjs()] },
  last_3_weeks: { label: 'Last 3 Weeks', value: [dayjs().subtract(21, 'd'), dayjs()] },
  last_7_days: { label: 'Last 7 Days', value: [dayjs().subtract(7, 'd'), dayjs()] },
  last_month: { label: 'Last Month', value: [dayjs().subtract(1, 'months'), dayjs()] },
  last_2_months: { label: 'Last 2 Months', value: [dayjs().subtract(2, 'months'), dayjs()] },
  last_3_months: { label: 'Last 3 Months', value: [dayjs().subtract(3, 'months'), dayjs()] },
};

export const defaultPresetKeys: TPresetKey[] = ['last_week', 'last_2_weeks', 'last_3_weeks'];
